import { render } from "./Article-bottom-ads-banner.vue?vue&type=template&id=ca0277e4"
import script from "./Article-bottom-ads-banner.vue?vue&type=script&lang=js"
export * from "./Article-bottom-ads-banner.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__